import {country} from './country';

export const commercial = function (item = null) {
    return {
        id: item == null ? null : item.id,
        firstName: item == null ? null : item.firstName,
        lastName: item == null ? null : item.lastName,
        email: item == null ? null : item.email,
        society: item == null ? null : item.society,
        lastLogin: item == null ? null : item.lastLogin,
        country: country(item == null ? null : item.country),
        status: item == null ? null : item.status,
        phone: item == null ? null : item.phone,
        phoneNumberCode: item == null ? null : item.phoneNumberCode
    };
};
